import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black shadow-lg">
      <div className="max-w-7xl mx-auto px-4 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/782f941cadc721090df4a2e82e5924dd.jpeg"
              alt="Elite Performance Lab Logo"
              className="h-10 w-10 md:h-14 md:w-14 object-contain rounded-full"
            />
          </div>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('programs')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-teal-400 hover:text-teal-300">
              Programs
            </button>
            <Link to="/speed-agility" className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-teal-400 hover:text-teal-300">
              Speed & Agility
            </Link>
            <Link to="/pricing" className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-teal-400 hover:text-teal-300">
              Pricing
            </Link>
            <button onClick={() => scrollToSection('technology')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-teal-400 hover:text-teal-300">
              Technology
            </button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-teal-400 hover:text-teal-300">
              About
            </button>

            {/* Social icons */}
            <div className="flex items-center gap-2 border-l border-gray-700 pl-6">
              <a
                href="https://www.instagram.com/elite_performance_lab"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com/ElitePerformanceLab1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com/@eliteperformancelab"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>

            <button onClick={() => scrollToSection('contact')} className="px-6 py-2.5 bg-teal-500 text-white text-sm font-semibold rounded-full hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap">
              Contact Us
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="md:hidden bg-black border-t border-gray-800 px-4 py-4 flex flex-col gap-4">
          <button onClick={() => scrollToSection('programs')} className="text-base font-medium text-teal-400 hover:text-teal-300 text-left cursor-pointer py-2 border-b border-gray-800">
            Programs
          </button>
          <Link to="/speed-agility" onClick={() => setMenuOpen(false)} className="text-base font-medium text-teal-400 hover:text-teal-300 cursor-pointer py-2 border-b border-gray-800">
            Speed & Agility
          </Link>
          <Link to="/pricing" onClick={() => setMenuOpen(false)} className="text-base font-medium text-teal-400 hover:text-teal-300 cursor-pointer py-2 border-b border-gray-800">
            Pricing
          </Link>
          <button onClick={() => scrollToSection('technology')} className="text-base font-medium text-teal-400 hover:text-teal-300 text-left cursor-pointer py-2 border-b border-gray-800">
            Technology
          </button>
          <button onClick={() => scrollToSection('about')} className="text-base font-medium text-teal-400 hover:text-teal-300 text-left cursor-pointer py-2 border-b border-gray-800">
            About
          </button>
          <button onClick={() => scrollToSection('contact')} className="w-full py-3 bg-teal-500 text-white text-base font-semibold rounded-full hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap mt-2">
            Contact Us
          </button>
        </div>
      )}
    </nav>
  );
}
